import React, { Component } from "react";

export default class CarImage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}
  componentDidUpdate(prevProps, prevState) {
    // Handle route parameter changes
    if (prevProps.prevCarImage !== this.props.prevCarImage) {
     // console.log("this.props.prevCarImage", this.props.prevCarImage);
    }
  }
  render() {
    const { data } = this.props;
    //console.log("this.props.prevCarImage", this.props.prevCarImage);

    return (
      <>
        {this.props.prevCarImage && this.props.prevCarImage}
        <div className="carImage">
          <img alt={data.kirjeldus} src={data.img} />
          <img className="blurred" alt={data.kirjeldus} src={data.img} />
        </div>
          {data.staatus === "Laos" && (
            <img className="badge" src="./assets/images/laos.svg" />
          )}
      </>
    );
  }
}
